import { Component, ComponentInterface, Host, h, Element, State } from '@stencil/core';
import { TranslateService } from '../../../services';

@Component({
  tag: 'av-translate',
  shadow: true,
  assetsDirs: ['auvious-i18n']
})
export class AvTranslate implements ComponentInterface {

  @Element() el: HTMLElement;
  @State() translations;

  constructor() {
    TranslateService.getTranslations().subscribe(map => this.translations = map);
  }

  render() {
    const translation = this.translations[this.el.textContent] || this.el.textContent;
    return <Host>{!translation ? <slot></slot> : translation}</Host>;
  }

}
